import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    height: '100%',
  },
}));

export default function DialogContent({ className = '', children }) {
  const classes = useStyles();

  return <div className={`${className} ${classes.content}`}>{children}</div>;
}
